import { render, staticRenderFns } from "./editAppointment.vue?vue&type=template&id=1f084a28&scoped=true"
import script from "./editAppointment.vue?vue&type=script&lang=js"
export * from "./editAppointment.vue?vue&type=script&lang=js"
import style0 from "./editAppointment.vue?vue&type=style&index=0&id=1f084a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f084a28",
  null
  
)

export default component.exports